import React,{ useState,useEffect} from 'react'
import DataTable from '../Components/Molecules/Table/DataTable'

import _ from "lodash";
import {
  CalendarInput,
  FormDropdown,
  FormField,
  FormFieldMail,
  FormTextArea,
} from "../Components/Molecules/FormField/FormField";
import { useFormik } from "formik";
import * as Yup from "yup";
import Card from "../Components/Atoms/Card/Card";
import ErrorLabel from "../Components/Atoms/ErrorLabel/ErrorLabel";
import thosuandSeparator from "../Helpers/thousandSeparator";
import {
  CancelButton,
  PrimaryButton,
} from "../Components/Atoms/Button/Button";
import RadioButton from "../Components/Atoms/RadioButton/RadioButton";
import { SingleDatePicker } from "../Components/Atoms/SingleDatePicker/SingleDatePicker";
//import styles from "./Dashboard.module.scss";
import HBar from "../Components/Bars/Bars";
import {apply_loan,customer_list,branch_list,constuser_subscription_list,get_master_data} from "../Enums/api_constunts"
import {postMethod} from "../Helpers/services"
import { showToast } from "../Components/Atoms/ToastNotifier/ToastNotifier";
import { useSelector } from "react-redux";

export default function MysubscriptionList() {
const [branchList, setBranchList] = useState([])
const  [selectedRow, setSelectedRow] = useState(null)
const [OpenForm,setOpenForm] = useState(0)
const userData = useSelector((state) => state.auth.user);
const [filterData,setFilterData] = useState({"page":1,"per_page":25,"role_id":[3],"search_string":""}
)

const [serviceTypes,setServiceTypes] = useState([])
const [selectedServiceType, setSelectedServiceType] = useState(null)
const getMasterData = ()=>{
  let postData = {"categories":["md_service_types"]};
  //values["tenant_id"] = _.get(selectedTenant,"id");
   postMethod(get_master_data,postData).then((res)=>{
    

   let md_service_types =   _.get(res,"result.md_service_types",[]).map((item)=>{
      item["label"] =  item["name"]
      
      return item
    });
    setServiceTypes(md_service_types)
    
  })
}
useEffect(()=>{
  getMasterData()
},[])
  const columnDefs = [
    { headerName: "ID", field: "index" ,width: 80},
    { headerName: "Plan Name", field: "plan_details.name", minWidth:150},
    { headerName: "Amount", field: "payment_amount",minWidth:150 },
    { headerName: "Plan Effect From", field: "start_date",minWidth:150 },
    { headerName: "Plan End Date", field: "end_date",minWidth:150 },
    { headerName: "Payment Status", field: "payment_status",minWidth:150 },
   
  ];

  //columnDefs.push( { headerName: "Actions", field: "actions",maxWidth:10000 },)

  const [isSpinner, setIsSpinner] = useState(false);
  const handleSubmit = (values) => {
    setIsSpinner(true);
    
     values["tenant_id"] = _.get(selectedTenant,"id");
     values["user_id"] = _.get(selectedUser,"id");
     values["service_type_id"] = _.get(selectedServiceType,"id");

     postMethod(apply_loan,values).then((res)=>{
      console.log(res)
      setOpenForm(0)
      setIsSpinner(false);
      setSelectedUser(null)
      setSelectedServiceType(null)
      setOpenForm(0)
      showToast("success",_.get(res, "message","Something went wrong!"))
    }).catch ((error)=>{
      showToast("error",_.get(error, "message","Something went wrong!"))
      setIsSpinner(false);

    })
  };

  const [selectedTenant, setSelectedTenant ] = useState(()=>{
    if(_.get(userData, "tenant_details",null) !=null){
        return { ...userData["tenant_details"], "label":userData["tenant_details"]["name"] }
     
      
    }else{
      return null
    }
      
  })
  const getBranchList = ()=>{
    let postData = {
      "search_string": "",
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "status_ids": []
    }
    postMethod(branch_list,postData).then((res)=>{
      if(_.get(res, "list.length") >0){
        let list = res["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        setBranchList(list);
      }
      
    })

  }
  useEffect(()=>{
    //if(OpenForm ==1 && _.get(userData,"role_id") ==1){
      getBranchList();
    //}
    
  },[OpenForm])

  useEffect(()=>{
    
     
      get_users()
    
    
  },[selectedTenant])
  

  /*
  
  {
  "email": "user@example.com",
  "first_name": "string",
  "last_name": "string",
  "mobile_no": "string",
  "experience": 0,
  "profile_image": "string",
  "role_id": 0,
  "tenant_id": 0
}
  */
 let formData = {
  service_type_id:  Yup.string()
    .matches(/^[0-9]+$/, "Only numbers are allowed")
  
}
let initialValues ={
  
  service_type_id: "",
  tenant_id:_.get(selectedTenant,"name","somthing")
  
}
if(_.get(userData,"role_id") ==1){
  formData["tenant_id"] = Yup.string()
  .required("Branch is required")
  //.matches(/^[1-9 + -]+$/, "Only numbers are allowed")
  //initialValues["tenant_id"] = _.get(selectedTenant,"name","somthing")
}

  let formik = useFormik({
    initialValues:initialValues,
    validationSchema: Yup.object(formData),
    onSubmit: handleSubmit,
    validateOnBlur: true,
    validateOnChange: true,
  });

  
  const getDetails = (row)=>{
    /*
    email:''
     first_name: "",
  last_name: "",
  mobile_no: "",
  experience: "",
    */
    setSelectedRow(row)
    formik.setFieldValue("email", _.get(row,"email",""))
    formik.setFieldValue("first_name", _.get(row,"first_name",""))
    formik.setFieldValue("last_name", _.get(row,"last_name",""))
    formik.setFieldValue("mobile_no", _.get(row,"mobile_no",""))
    formik.setFieldValue("experience", _.get(row,"experience",""))
    if(_.get(row,"admin_tenant_details",false)){
      setSelectedTenant(row["admin_tenant_details"])
      formik.setFieldValue("tenant_id", _.get(row,"admin_tenant_details.name",""))
    }
    
   
    setOpenForm(1)

  }

  useEffect(()=>{
    if(OpenForm !=1){
      formik.resetForm();
      setSelectedRow(null)
    }
   
  },[OpenForm])
  
  const [usersList,setUsersList] = useState([])
  const [selectedUser, setSelectedUser ]  = useState(null)
  const get_users = (text)=>{

    //customer_list
    let postData = {
      "search_string": text,
      "page": 1,
      "per_page": 100,
      "created_on": "",
      "created_to": "",
      "sort_by": "id",
      "sort_order": "desc",
      "role_id": [3]
    }
    if(_.get(userData, "role_id") ==1){
      if(_.get(selectedTenant, "id")){
        postData["tenant_id"] = [_.get(selectedTenant, "id")]
      }
    }else{
      postData["tenant_id"] = [_.get(userData, "tenant_id")]
           
    }
    
    postMethod(customer_list,postData).then((res)=>{
      
      if(_.get(res, "result.list.length") >0){
        let list = res["result"]["list"].map((item)=>{
          item["label"] =  item["name"]
          
          return item
        });
        
        setUsersList(list);
      }
      
    })


  }
  
  return (
    <div>
       <h3>Subscriptions</h3>
        <div className={'mt-3'}>
           <DataTable loaded_from="MY_SUBSCRIPTIONS_LIST" columnDefs={columnDefs} apiUrl={constuser_subscription_list} setFilterData={setFilterData} filterData={filterData} setOpenForm={(v)=>{ setOpenForm(1)}} editRow={(item)=>{getDetails(item)}} showCreateBtn={false} />
          
          
        </div>
    </div>
  )
}
